import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as _util from '../../services/utilities';
import * as _errorHandler from '../../services/errorhandler';
import { UnitOfWorkService } from '../../services/unitOfWork/unitOfWork.service';
import { OpenIdConnectService } from '../../services/oidc/open-id-connect.service';
import { ApplicationInsightsService } from '../../services/appInsights/application-insights.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BusyService } from '../../services/busy.service';
@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['admin.component.css']
})
export class AdminComponent {
    public wsRights: model.workspaceRight[];
    public wsRight: model.workspaceRight = null;
    public libraries: string[] = [
        "Alliance",
        "Assurance",
        "Assurance_new",
        "BDO",
        "Board",
        "CIM",
        "Tax"
    ];

    handler = _errorHandler.includeIn(this);

    constructor(private uow: UnitOfWorkService, private oidcService: OpenIdConnectService, private ai: ApplicationInsightsService, private toastr: ToastrService, private busy: BusyService) {
        ai.logPageView();

        this.busy.set({ key: 'ws-load', isBusy: true, message: 'Retrieving rights table' });
        uow.getAdminWorkspaceRights()
            .then(data => {
                this.wsRights = data;
                this.busy.set({ key: 'ws-load', isBusy: false });
            })
            .catch(reason => {
                this.handler.handleError(reason);
                this.busy.set({ key: 'ws-load', isBusy: false });
            });
    }

    create() {
        if (!this.wsRight) {
            this.wsRight = this.uow.workspaceRights.createEntity();
        }
    }

    edit(ws: model.workspaceRight) {
        this.wsRight = ws;
    }

    update() {
        if (this.wsRight.id == -1)
            this.wsRights.push(this.wsRight);
        //this.save();
        this.wsRight = null;
    }

    remove(ws: model.workspaceRight) {
        if (confirm("Confirm deletion?")) {
            ws.isDeleted = true;  //ws.entityAspect.setDeleted();
            var idx = this.wsRights.indexOf(ws);
            if (idx > -1) {
                this.wsRights.splice(idx, 1);
            }
            //this.save();
        }
    }

    save() {
        if (this.uow.hasChanges.value) {
            this.busy.set({ key: 'ws-save', isBusy: true, message: 'Saving changes' });
            this.uow.commit()
                .then(() => {
                    this.busy.set({ key: 'ws-save', isBusy: false });
                })
                .catch(reason => {
                    this.handler.handleError(reason);
                    this.busy.set({ key: 'ws-save', isBusy: false });
                });
        } else {
            this.toastr.error("No changes to save");
        }
    }

    cancel() {
        this.wsRight = null;
    }

    canDeactivate(): Observable<boolean> | boolean {
        if (!this.uow.hasChanges.value)
            return true;
        
        return confirm("You have unsaved changes, are you sure you want to leave this page?");
    }
}
